<button
  *ngIf="enabled"
  #dropButton
  type="button"
  class="assistant-drop"
  [class.assistant-drop--open]="isOpen"
  [class.assistant-drop--covered]="isOpen && isPanel"
  [attr.aria-label]="isOpen ? 'Згорнути помічника' : 'Помічник кабінету'"
  [attr.aria-expanded]="isOpen"
  aria-controls="assistant-chat"
  (click)="toggle()"
>
  <svg class="assistant-drop__icon" viewBox="0 0 24 24" aria-hidden="true">
    <path class="assistant-drop__body" d="M12 2.6c-.3 0-.6.15-.78.39C9.5 5.3 5.6 10.5 5.6 14.4a6.4 6.4 0 0 0 12.8 0c0-3.9-3.9-9.1-5.62-11.41A.98.98 0 0 0 12 2.6z"/>
    <path class="assistant-drop__shine" d="M9.1 14.6a2.9 2.9 0 0 0 2.9 2.9"/>
  </svg>
</button>

<section
  *ngIf="isOpen"
  id="assistant-chat"
  class="assistant-chat"
  [class.assistant-chat--panel]="isPanel"
  role="dialog"
  aria-label="Помічник кабінету"
>
  <header class="assistant-chat__head">
    <span class="assistant-chat__mark" aria-hidden="true">
      <svg viewBox="0 0 24 24"><path d="M12 2.6c-.3 0-.6.15-.78.39C9.5 5.3 5.6 10.5 5.6 14.4a6.4 6.4 0 0 0 12.8 0c0-3.9-3.9-9.1-5.62-11.41A.98.98 0 0 0 12 2.6z"/></svg>
    </span>

    <div class="assistant-chat__title">
      <b class="assistant-chat__name">Помічник</b>
      <span class="assistant-chat__hint">Ваші замовлення, товари й ціни</span>
    </div>

    <button
      type="button"
      class="assistant-chat__tool"
      title="Почати розмову заново"
      aria-label="Почати розмову заново"
      [disabled]="!enabled || isSending || isResetting || !messages.length"
      (click)="clear()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3"/>
        <path d="M4.5 4.5v3.7h3.7"/>
      </svg>
    </button>

    <button
      type="button"
      class="assistant-chat__tool assistant-chat__tool--layout"
      [title]="isPanel ? 'Згорнути у віконце' : 'Розгорнути панеллю справа'"
      [attr.aria-label]="isPanel ? 'Згорнути у віконце' : 'Розгорнути панеллю справа'"
      (click)="togglePanel()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3.5" y="4.5" width="17" height="15" rx="2"/>
        <path *ngIf="!isPanel" d="M14.5 4.5v15"/>
        <rect *ngIf="isPanel" x="12" y="11.5" width="5.5" height="5" rx="1"/>
      </svg>
    </button>

    <button
      type="button"
      class="assistant-chat__tool"
      title="Закрити"
      aria-label="Закрити"
      (click)="close()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/>
      </svg>
    </button>
  </header>

  <div #feed class="assistant-chat__feed" role="log" aria-live="polite">
    <p class="assistant-chat__empty" *ngIf="!messages.length && !isSending">
      Запитайте про свої замовлення, товари й ціни, баланс чи повернення - наприклад,
      «Знайди ADT322100» або «Де моє останнє замовлення?». Потрібну сторінку кабінету помічник відкриє сам.
    </p>

    <ng-container *ngFor="let message of messages; trackBy: trackByIndex; last as isLast">
      <div
        class="assistant-msg"
        [class.assistant-msg--user]="message.role === 'user'"
        [class.assistant-msg--error]="message.error"
        [class.assistant-msg--blocks]="!!message.blocks"
      >
        <!-- Картка #986: відповідь помічника - блоками, лише через шаблон; текст клієнта й збої - як є -->
        <ng-container *ngIf="message.blocks; else rawText">
          <ng-container *ngFor="let block of message.blocks">
            <p
              *ngIf="block.type === 'paragraph'"
              class="assistant-msg__para"
              [class.assistant-msg__para--heading]="block.heading"
            ><ng-container *ngTemplateOutlet="textLines; context: {$implicit: block.lines}"></ng-container></p>

            <ul *ngIf="block.type === 'list'" class="assistant-msg__list">
              <li *ngFor="let item of block.items"><ng-container *ngTemplateOutlet="textLines; context: {$implicit: item}"></ng-container></li>
            </ul>

            <ol *ngIf="block.type === 'steps'" class="assistant-msg__list assistant-msg__list--steps" [attr.start]="block.start">
              <li *ngFor="let item of block.items"><ng-container *ngTemplateOutlet="textLines; context: {$implicit: item}"></ng-container></li>
            </ol>
          </ng-container>
        </ng-container>
        <ng-template #rawText>{{ message.text }}</ng-template>
      </div>

      <div class="assistant-suggest" *ngIf="showOptions(message, isLast)" role="group" aria-label="Варіанти відповіді">
        <button
          *ngFor="let option of message.options"
          type="button"
          class="assistant-suggest__option"
          [title]="option.send"
          [disabled]="!enabled || isSending || isResetting"
          (click)="send(option)"
        >{{ option.text }}</button>
      </div>
    </ng-container>

    <div class="assistant-thinking" *ngIf="isSending">
      <span class="assistant-thinking__drops" aria-hidden="true"><i></i><i></i><i></i></span>
      Помічник думає
    </div>
  </div>

  <form class="assistant-chat__form" (ngSubmit)="send()">
    <textarea
      #input
      class="assistant-chat__input"
      name="assistantDraft"
      rows="1"
      placeholder="Ваше питання"
      aria-label="Ваше питання"
      [maxlength]="maxLength"
      [disabled]="!enabled"
      [(ngModel)]="draft"
      (input)="autosize()"
      (keydown)="onKeydown($event)"
    ></textarea>

    <button type="submit" class="assistant-chat__send" aria-label="Надіслати" title="Надіслати" [disabled]="!canSend">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 12h13M12.5 6l6 6-6 6"/>
      </svg>
    </button>
  </form>
</section>

<!-- Рядки абзацу чи пункту: між рядками - перенос; шматки - текст, жирне, посилання на сторінки кабінету -->
<ng-template #textLines let-lines>
  <ng-container *ngFor="let line of lines; first as isFirst"><br *ngIf="!isFirst"><ng-container *ngFor="let part of line"><a
    *ngIf="part.route; else plainPart"
    class="assistant-msg__link"
    [routerLink]="part.route"
    [queryParams]="part.query"
  ><strong *ngIf="part.bold; else linkText">{{ part.text }}</strong><ng-template #linkText>{{ part.text }}</ng-template></a><ng-template
    #plainPart
  ><strong *ngIf="part.bold; else plainText">{{ part.text }}</strong><ng-template #plainText>{{ part.text }}</ng-template></ng-template></ng-container></ng-container>
</ng-template>
